import { render, staticRenderFns } from "./AppraisalAcceptReview.vue?vue&type=template&id=a4be47bc"
import script from "./AppraisalAcceptReview.vue?vue&type=script&lang=js"
export * from "./AppraisalAcceptReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports